module.exports = __webpack_public_path__ + "img/certified.b6e2198.jpg";